import axios from '@/config/httpConfig'
//获取form的Submissions信息(收集数据)
export function getFormSubmissions(data) {
    return axios.post('/form/getFormSubmissions', data)
}